import fetch from "auth/FetchInterceptor";
import query from "devextreme/data/query";

const UserService = {};
const BasePath = '/user';


UserService.addUser = function (data) {
  return fetch({
    url: BasePath + "/",
    method: "Post",
    data: data
  });
};

UserService.getUserByCode = function (code) {
  return {
    queryKey: ['get_user_by_code', code],
    queryFn: () => fetch({
      url: "/user/" + code,
      method: "GET",
    })
  }
};


UserService.getUserById = function (id) {
  return {
    queryKey: ['get_user_by_id', id],
    queryFn: () => fetch({
      url: "/user/" + id,
      method: "GET",
    })
  }
};

UserService.getAdmins = function () {
  return fetch({
    url: "/user/getAllAdmins",
    method: "GET",
  });
};

UserService.updateAvatar = function (avatar) {
  var data = {
    action: "update_avatar",
    avatar
  }
  return fetch({
    url: BasePath + "/do_action",
    method: "Post",
    data: data
  });
};

UserService.updateUser = function (data) {
  data.action = "update_user";
  return fetch({
    url: BasePath + "/do_action",
    method: "Post",
    data: data
  });
};

UserService.updateAddress = function (data) {
  data.action = "update_address";
  return fetch({
    url: BasePath + "/do_action",
    method: "Post",
    data: data
  });
};

UserService.updateShopSettings = function (data) {
  data.action = "update_shop_settings";
  return fetch({
    url: BasePath + "/do_action",
    method: "Post",
    data: data
  });
};

UserService.getProfile = function () {
  return {
    queryKey: ['get_profile'],
    queryFn: () => fetch({
      url: BasePath + "/do_action",
      method: "Post",
      data: {
        action: "get_profile"
      }
    })
  }
}


UserService.changePassword = function (params) {
  params.action = "changePassword";
  return fetch({
    url: BasePath + "/do_action",
    method: "Post",
    data: params,
  });
};

UserService.block = function (params) {
  params.action = "blockUser";
  return fetch({
    url: BasePath + "/do_action",
    method: "Post",
    data: params,
  });
};

UserService.shopVerification = function ({ id, status }) {
  return fetch({
    url: BasePath + "/shop-verification/" + id,
    method: "Put",
    data: { status },
  });
};

UserService.verifyUser = function ({ id }) {
  return UserService.shopVerification({ id, status: "verified" });
};

UserService.rejectUser = function ({ id }) {
  return UserService.shopVerification({ id, status: "rejected" });
};

UserService.delete = function (params) {
  params.action = "delete_user";
  return fetch({
    url: BasePath + "/do_action",
    method: "Post",
    data: params,
  });
};

UserService.getUserLimit = function (params) {
  params.action = "get_user_credit_request_limit";
  return fetch({
    url: BasePath + "/do_action",
    method: "Post",
    data: params,
  });
};

UserService.saveThemeConfig = function (params) {
  params.action = "save_theme_config";
  return fetch({
    url: BasePath + "/do_action",
    method: "Post",
    data: params,
  });
};

UserService.getDashboard = function (data) {
  return fetch({
    url: "/user/adminDashboard",
    method: "Post",
    data: data
  });
}


UserService.getUsersByRole = function () {
  return fetch({
    url: "/user/getAll",
    method: "Get",
  });
};

UserService.getClients = function (params) {
  return fetch({
    url: "/user/getClients",
    method: "post",
    data: {
      ...params,
    },
  });
};
UserService.ValidateCin = function (data) {
  return fetch({
    url: "/validateCin",
    method: "post",
    data: data,
  });
};

UserService.ModifyUser = function (data) {
  return fetch({
    url: BasePath + "/" + data.id,
    method: "put",
    data: data,
  });
};


UserService.changeUserPassword = function (data) {
  data.action = 'changeUserPassword'
  return fetch({
    url: BasePath + "/do_action",
    method: "Post",
    data: data,
  });
};


UserService.getCredit = function () {
  return {
    queryKey: ['get_credit'],
    queryFn: () => fetch({
      url: BasePath + "/do_action",
      method: "post",
      data: { action: 'get_credit' },
    })
  }
};

UserService.addTransaction = function (data) {
  return fetch({
    url: "/transaction/add",
    method: "post",
    data: data,
  });
};

UserService.getTransactionTo = function (data) {
  return fetch({
    url: "/transaction/getAllWithUser/" + parseInt(data),
    method: "get",
  });
};

UserService.getCommissionsTotals = function (userId) {
  var data = {
    action: "salesmanCommission",
    userId: userId
  };
  return {
    queryKey: ['get_salesman_commissions', data],
    queryFn: () => fetch({
      url: BasePath + "/do_action",
      method: "Post",
      data: data
    })
  }
}

UserService.updateNotifiedAt = function (data) {
  data.action = 'update_notified_at';
  return fetch({
    url: BasePath + "/do_action",
    method: "Post",
    data: data
  })
}


export default UserService;
